import React, { useContext } from 'react';
import { IterationContext } from '../../contexts/IterationContext';
import Select from 'Components/GMS/Select';

type CategorySelectorProps = {
    id: string;
    categoryId?: string;
};

const CategorySelector: React.FC<CategorySelectorProps> = ({ id, categoryId }) => {
    const {
        allCategories,
        iterationPayload,
        handleCategoryChange
    } = useContext(IterationContext);

    const handleChange = (selectedCategoryId: string) => {
        handleCategoryChange(selectedCategoryId);
    };

    return (
        <div className="tw-mt-4 tw-w-[25%] tw-ms-7">
            <label htmlFor="category-select" className="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">
                Select Category
            </label>
            <Select
                id={`${id}-category-select`}
                onChange={handleChange}
                value={iterationPayload?.category_id || categoryId || ""}
                options={(allCategories || []).map(category => ({
                    value: category.id,
                    label: category.name
                }))}
                name={"Select"}
                hideLabel={true}
                isSearchable
                hasMarginAtStart={false}
                data-testid="category-dropdown"
            />
        </div>
    );
};

export default CategorySelector;